import { Link } from "react-router-dom";
import { Linkedin, Heart, X } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-100">
      <div className="container mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Company Info - Full width on mobile */}
          <div className="col-span-2 sm:col-span-2 md:col-span-1 space-y-4">
            <div className="flex items-center gap-2">
              <img 
                src="/lovable-uploads/aad0c645-89f5-4dd6-bf0d-04384e55a2bf.png" 
                alt="Spharaka Logo" 
                className="h-7 md:h-8"
                width="197"
                height="32"
                loading="lazy"
              />
            </div>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              Transforming cybersecurity with Agentic AI to provide autonomous detection and response across your entire digital ecosystem.
            </p>
            <div className="text-xs sm:text-sm text-gray-600">
              Hyderabad | Bangalore
            </div>
            <div className="flex items-center space-x-4">
              <a href="https://www.linkedin.com/company/spharaka/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#8932c8]" aria-label="Visit Spharaka on LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://x.com/spharaka" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#8932c8]" aria-label="Follow Spharaka on X (Twitter)">
                <X className="h-5 w-5" />
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <img 
                src="/lovable-uploads/15434582-e5bc-4d26-886c-4d1cddc2c697.png" 
                alt="ISO 27001 Certification"
                className="h-7 w-7 md:h-8 md:w-8"
                width="43"
                height="32"
                loading="lazy"
              />
              <span className="text-xs text-gray-600">ISO 27001 Certified</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-3 md:mb-4">Products</h3>
            <ul className="space-y-2">
              <li><Link to="/products/spharakaxdr" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Spharaka XDR</Link></li>
              <li><Link to="/products/auraxp" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">AuraXP</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-3 md:mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/blogs" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Insights</Link></li>
              <li><Link to="/blogs/ultimate-guide-ai-xdr" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Guide</Link></li>
              <li><a href="/datasheet.html" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Data Sheet</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-3 md:mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">About Us</Link></li>
              <li><Link to="/careers" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Careers</Link></li>
              <li><Link to="/partners/mssp" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Partners</Link></li>
              <li><Link to="/contact" className="text-xs sm:text-sm text-gray-600 hover:text-[#8932c8]">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-8 md:mt-12 pt-6 md:pt-8">
          <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-center">
            <div className="text-xs sm:text-sm text-gray-500 text-center md:text-left">
              © 2025 Spharaka Networks Private Limited. All rights reserved.
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
              <div className="flex items-center gap-4 sm:gap-6">
                <Link to="/privacy-policy" className="text-xs sm:text-sm text-gray-500 hover:text-[#8932c8]">Privacy Policy</Link>
                <Link to="/terms-of-service" className="text-xs sm:text-sm text-gray-500 hover:text-[#8932c8]">Terms of Service</Link>
              </div>
              <div className="flex items-center justify-center gap-1 text-xs sm:text-sm text-gray-500">
                <span>Made with</span>
                <Heart className="h-3 w-3 sm:h-4 sm:w-4 text-red-500 fill-current" />
                <span>from India</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;